import React, { Component } from 'react';
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {toggleDarkMode} from "../../actions/preferenceActions";

class Footer extends Component {
    render() {
        let { _preferences: preferences } = this.props;
        return (
            <>
                {/* start footer Area */}
                <footer className="footer-area">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="footer-top flex-column">
                                    <div className="footer-logo">
                                        <Link to="#">
                                            <img src={ require('./../../img/logo.png') } alt="" />
                                        </Link>
                                        <h4>

                                        </h4>
                                    </div>
                                    <div className="footer-social">
                                        <a href={ preferences._network.facebook }><i className="fab fa-facebook-square"> </i></a>
                                        <a href={ preferences._network.twitter }><i className="fab fa-twitter-square"> </i></a>
                                        <a href={ preferences._network.stackoverflow }><i className="fab fa-stack-overflow"> </i></a>
                                        <a href={ preferences._network.github }><i className="fab fa-github-square"> </i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row footer-bottom justify-content-center">
                            <p className="col-lg-8 col-sm-12 footer-text">
                                Copyright &copy; { new Date().getFullYear() } Tous droits réservés | Créé par <Link to="/about">{ preferences._author }</Link>
                                <span className="footer-separator"> | </span>
                                <Link to="/newsletter/unsubscribe" className="footer-unsubscribe-link">Se désabonner de la newsletter</Link>
                            </p>
                        </div>
                    </div>
                </footer>
                {/* End footer Area */}
            </>
        );
    }
}

Footer.protoType = {
    _preferences: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    _preferences: state._preferences
});

export default connect(
  mapStateToProps,
  { toggleDarkMode }
)(Footer);